import type { RouteRecordRaw } from "vue-router";

export const routes = [
  {
    path: "/enrollment/:routeZip([0-9]{5})?",
    name: "Zip Enrollment",
    component: () => import("./zipEnrollment.vue"),
    props: true,
  },
  {
    path: "/make-a-payment",
    name: "Make a Payment",
    component: () => import("./anonymousMakePayment.vue"),
  },
  {
    path: "/renew/:pin?",
    name: "Anonymous Choice Renewal",
    component: () => import("./cwAnonymousChoiceRenewal.vue"),
  },
  {
    path: "/quote",
    name: "View and Sign Contract",
    component: () => import("./cwPcmViewContract.vue"),
  },
  {
    path: "/choice-disclosures/environmental-disclosure/:productSlug?/:stateAbbr?",
    name: "Environmental Disclosure",
    component: () => import("./choiceDisclosures/environmentalDisclosure.vue"),
    props: true,
  },
  {
    path: "/choice-disclosures/variable-price-history/:productSlug?/:stateAbbr?",
    name: "Variable Price History",
    component: () => import("./choiceDisclosures/variablePriceHistory.vue"),
    props: true,
  },
  {
    path: "/commercial-credit-application/:creditAppGuid",
    name: "Commercial Credit Application",
    component: () => import("./cwCommercialCreditApp.vue"),
    props: true,
  },
  {
    path: "/unsubscribe",
    name: "Unsubscribe",
    component: () => import("./correspondence/unsubscribeNotification.vue"),
  },
  {
    path: "/correspondence/:correspondenceType",
    name: "Customer Correspondence",
    component: () => import("./correspondence/anonymousCorrespondence.vue"),
    props: true,
  },
  {
    path: "/order-now",
    name: "Order Now",
    component: () => import("./orderNow/orderNowPage.vue"),
  },
  {
    path: "/on-demand-delivery",
    name: "On Demand Delivery",
    component: () => import("./correspondence/oneClickOrderPage.vue"),
  },
  {
    path: "/shop/hvac-service",
    name: "Schedule HVAC Service",
    component: () => import("./guidedExperience/anonymousHvacScheduleWizard.vue"),
  },
  {
    path: "/shop/:productSlug/:privatePlanSlug",
    name: "Private Price Plan Enrollment",
    component: () => import("./guidedExperience/privatePricePlanEnrollment.vue"),
  },
  {
    path: "/shop/:productSlug?",
    name: "Guided Experience",
    component: () => import("./guidedExperience/guidedExperience.vue"),
  },
  {
    path: "/confirm-enrollment/:pin?",
    name: "Confirm Enrollment",
    component: () => import("./cwConfirmEnrollment.vue"),
  },
  {
    path: "/hub/:slug",
    name: "Content Page",
    component: () => import("./genericContentPage.vue"),
    props: true,
  },
] satisfies RouteRecordRaw[];
